export function renderAppImage(path, img) {
    return `${path}RenderAppImagePath?path=${img}`;
}
